<template>
  <div class="w-full z-0">
    <header>
      <Header />
    </header>

    <div>
      <slot />

    </div>

    <div>
      <FloatingWhatsButton />
    </div>
    <FooterDisclaimer />
    <footer>
      <FooterSite />
    </footer>
  </div>
</template>

<script setup>
import Header from "../components/SiteHome/Header.vue";
import FloatingWhatsButton from "~/components/SiteHome/FloatingWhatsButton.vue";
import FooterSite from "~/components/SiteHome/FooterSite.vue";
import FooterDisclaimer from "~/components/SiteHome/FooterDisclaimer.vue";
</script>